module.exports = __webpack_public_path__ + "static/Glenn-5afc0089ab7ea1a1692f50b4e74db6c6.png";